import { useEffect, useState } from "react";

import { LinkButton, useMember, useLanguage } from "../../components";
import { UiContactFormModel } from "../../models";
import { MapModelToProps } from "../../utils";

import { ContactFormContainer } from "./UiContactForm.styles";

declare global {
    interface Window {
        // eslint-disable-next-line
        jsAppShim: any;
        locale: string;
    }
}

export type UiContactFormProps = MapModelToProps<UiContactFormModel>;

const UiContactForm = ({ model }: UiContactFormProps) => {
    const member = useMember();
    const language = useLanguage();
    const { button } = model.content;
    const [formOpen, setFormOpen] = useState(!button); //if button exists, form starts closed

    //get user info
    const userid = member.status === "resolved" ? member.value.id : "";
    const email = member.status === "resolved" ? member.value.email : "";
    const username = member.status === "resolved" ? member.value.fullName : "";

    //load script
    useEffect(() => {
        //wait for member status to be resolved
        if (member.status === "pending") return;

        const script = document.createElement("script");
        script.async = true;
        script.src = `https://support-form-app-ui.${
            location.host === "trello.com" ? "prod-east" : "stg-east"
        }.frontend.public.atl-paas.net/assets/js-app-shim.js`;
        script.onload = () => {
            window.locale = language;
            window.jsAppShim({
                appTargetId: "support-form-app",
                assetManifest:
                    "https://support-form-app-ui." +
                    (location.host === "trello.com"
                        ? "prod-east"
                        : "stg-east") +
                    `.frontend.public.atl-paas.net/assets/asset-manifest.json?v=${new Date().getTime()}`,
                position: "after",
                scripts: ["trello.js"],
                target: "#new-support-form-app"
            });
        };
        document.body.appendChild(script);
    }, [member, language]);

    return (
        <>
            {!formOpen && button?.content && (
                <LinkButton
                    {...button.content.buttonTheme?.content}
                    onClick={() => {
                        setFormOpen(true);
                    }}
                    url={button.content.url}
                >
                    {button.content.text}
                </LinkButton>
            )}
            <ContactFormContainer
                data-trelloemail={email}
                data-trellouserid={userid}
                data-trellousername={username}
                id="new-support-form-app-container"
                data-open={formOpen}
            >
                <div id="new-support-form-app" />
            </ContactFormContainer>
        </>
    );
};

export default UiContactForm;
